import map from 'lodash/map'
import slice from 'lodash/slice'
import React from 'react'
import { Avatar } from './index'
import styles from './AvatarGroup.module.scss'
export type AvatarGroupItem = { name?: string; src?: string; value?: string }
export type AvatarGroupProps = { dataArray?: AvatarGroupItem[]; size?: number; max?: number }
export const AvatarGroup = ({ dataArray, max = 5, size }: AvatarGroupProps) => {
  dataArray = slice(dataArray, 0, max)

  return (
    <div className={styles.avatarGroup}>
      {map(dataArray, (e) => (
        <Avatar key={e.name ?? e.src ?? e.value} size={size} {...e} />
      ))}
    </div>
  )
}
